module.exports = __webpack_public_path__ + "img/console07.23e81475.jpg";